<div class="content-container" role="main" aria-live="assertive">
  @if (mainTheme !== themeType.Custom) {
    <id-card>
      <ng-container *ngTemplateOutlet="totpAuthenticationContent"></ng-container>
    </id-card>
  } @else {
    <div class="custom-card">
      <ng-container *ngTemplateOutlet="totpAuthenticationContent"></ng-container>
    </div>
  }

  <ng-template #totpAuthenticationContent>
    <div class="flex flex-column flex-align-center">
      <h1 class="{{ mainTheme !== themeType.Custom ? 'ids-heading-xl' : 'custom-heading-xl' }}">{{ getTypeText() }}</h1>
      <h2 class="{{ mainTheme !== themeType.Custom ? 'ids-heading-l' : 'custom-heading-l' }} ids-mb-3">
        {{ clientInfo?.organizationName }}
      </h2>

      <totp-authentication-form (loginRequest)="login($event)"></totp-authentication-form>
    </div>
  </ng-template>
</div>
